export default __webpack_public_path__ + "static/media/firefighing.8002e999.png";